<template lang="pug">
  div
    app-modal(
      v-if="showModal"
      titulo="Vincular Georreferenciamento ao Cadastro",
      :width="700",
      @closeModal="closeModal",
    )
      template(slot="body")
        validation-provider(rules="required|numeroRecibo", v-slot="{ errors }", ref="validationModal")
          app-label(label="Informe o número do recibo:")
          el-input(
            v-model="numeroRecibo",
            v-mask="['AAA-XXXXXX-XXXXXXX-####']"
          )
          span.help.erro {{ errors[0] }}
      template(slot="footer")
        div.buttons
          el-button(
            @click="closeModal"
          ) Cancelar
          el-button(
            type="primary",
            key="botao-confirma",
            @click="vincularRecibo"
          ) Confirmar

    app-modal(
      v-if="showModalVisualizarCadastro",
      titulo="Visualizar Cadastro",
      @closeModal="closeModal",
      :width="1000",
      :height="700"
      :bodyStyle="{height: 'auto', padding: '0'}"
    )
      template(slot="body")
        div.dados-cadastro
          cadastro-offline(
            :processo="dadosModal.processo",
            :isRelatorio="true", versaoSelecionada="0.1",
            versaoCadastro = "0.1",
            :isCadastroPendente="true",
            :isGeoCadastro="dadosModal.isGeoCadastro"
          )
    el-card.card-container(shadow="hover")
      filtro(
        placeholder="Informe o número do recibo ou CPF/CNPJ do interessado"
        @pesquisar="pesquisar",
        @limpar="clear",
        :configuracaoFiltro="configuracaoFiltro",
        :showFiltroTipoMultiplo="filtro.showFiltroTipoProcessoMultiplo"
        :showFiltroNumeroProcesso="false"
      )
    app-listagem(
      header-label="Listagem de cadastros"
      :hasRowClick="true",
      :jsonHeaders="colunas",
      :jsonData="items",
      :pagina="filtro.pagina",
      :totalElements="totalElements",
      :filtro="filtro"
      :hasActionButton="true",
      typeActionButton="success",
      nameActionButton="Cadastrar",
      sizeActionButton="medium",
      @click="criarCadastroGeo"
      :hasRefreshButton="true",
      @updateListagem="refresh",
      @changePage="changePage",
      @sort="sort",
      @executar="executar"
    )
</template>

<script>
import CadastroOffline from '@/components/InformacoesCadastroOffline'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from '@/components/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import BaseFiltro from '@/screens/receptor/ba/BaseFiltroCadastroProvisorio.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModal from '@/components/AppModal.vue'
import AppLabel from '@/components/AppLabel.vue'
import { mapActions } from 'vuex'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppListagem,
    Filtro,
    AppModal,
    AppLabel,
    CadastroOffline
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CADASTROS_PENDENTES_GEORREFERENCIAMENTO'),
      totalProcessos: 0,
      isBusca: false,
      loading: false,
      processos: [],
      colunas: [
        { id: 0, titulo: 'Número do Recibo', propriedade: 'numeroRecibo', ordem: 1, acoes: [] },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Tipo de processo', propriedade: 'tipoFormatado', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Situação', propriedade: 'statusFormatado', ordem: 5, acoes: [] },
        {
          id: 5, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Cadastro', icone: 'fa-eye', codigo: 'VISUALIZAR_CADASTRO_GEO', ordem: 1, show: this.showVisualizarCadastroGeo },
            { id: 1, nome: 'Editar', icone: 'fa-edit', codigo: 'EDITAR_CADASTRO_GEO', ordem: 2, show: this.showEditarCadastroGeo },
            { id: 2, nome: 'Excluir', icone: 'fa-trash', codigo: 'REMOVER_CADASTRO_GEO', ordem: 3 },
            { id: 3, nome: 'Inserir número do recibo', icone: 'fa-pencil-alt', codigo: 'INSERIR_NUMERO_RECIBO', ordem: 4, show: this.showInserirNumeroRecibo }
          ]
        }
      ],
      items: [],
      configuracaoFiltro: {
        filtroNumeroRecibo: filtro?.filtroNumeroRecibo?.CADASTROS_PENDENTES_GEORREFERENCIAMENTO || [],
        filtroSituacao: filtro?.filtroSituacao?.CADASTROS_PENDENTES_GEORREFERENCIAMENTO || []
      },
      totalElements: 0,
      showModal: false,
      showModalVisualizarCadastro: false,
      dadosModal: { numeroRecibo: '', id: '' }
    }
  },

  computed: {
    numeroRecibo: {
      get () {
        return this.dadosModal.numeroRecibo
      },
      set (value) {
        this.dadosModal.numeroRecibo = value.toUpperCase()
      }
    }
  },

  methods: {
    ...mapActions({
      removerAnalise: 'analiseGeo/removerAnalise',
      vincularGeoCadastro: 'analiseGeo/vincular',
      getCadastroProvisorioByRecibo: 'cadastroProvisorio/getCadastroProvisorioByRecibo',
      getCadastroGeo: 'analiseGeo/getCadastroGeo'
    }),
    criarCadastroGeo () {
      this.$router.push({
        name: '/gerar-geo-cadastro-pendente'
      })
    },
    async VISUALIZAR_CADASTRO_GEO (_this, { item }) {
      if (item.numeroRecibo) {
        const cadastroProvisorioAux = await this.getCadastroProvisorioByRecibo(item.numeroRecibo)
        const jsonCadastro = JSON.parse(cadastroProvisorioAux.jsonCadastro)

        if (cadastroProvisorioAux.analiseGeorreferenciamento) {
          cadastroProvisorioAux.analiseGeorreferenciamento.possuiGeorreferenciamento = 'POSSUI'
          cadastroProvisorioAux.analiseGeorreferenciamento.localizacoes = []
          jsonCadastro.dados.cadastro.georreferenciamento = cadastroProvisorioAux.analiseGeorreferenciamento
        }
        jsonCadastro.dados.cadastro.tipo = cadastroProvisorioAux.tipo.codigo
        jsonCadastro.dados.cadastro.protocolo = cadastroProvisorioAux.numeroRecibo
        this.dadosModal.processo = {
          dadosCadastro: jsonCadastro,
          tipo: cadastroProvisorioAux.tipo,
          pessoas: cadastroProvisorioAux.pessoas,
          dataCadastro: cadastroProvisorioAux.dataCriacao
        }
        this.dadosModal.isGeoCadastro = false
      } else {
        const cadastroGeo = await this.getCadastroGeo(item.id)
        const dadosCadastro = {dados: {cadastro: {georreferenciamento: cadastroGeo}}}
        dadosCadastro.dados.cadastro.georreferenciamento.possuiGeorreferenciamento = 'POSSUI'
        dadosCadastro.dados.cadastro.georreferenciamento.localizacoes = []
        this.dadosModal.processo = {
          dadosCadastro: dadosCadastro,
          tipo: ''
        }
        this.dadosModal.isGeoCadastro = true
      }
      this.showModalVisualizarCadastro = true
    },
    EDITAR_CADASTRO_GEO (_this, { item }) {
      this.$router.push({
        name: '/gerar-geo-cadastro-pendente',
        params: {
          idCadastroGeo: item.id
        }
      })
    },
    async REMOVER_CADASTRO_GEO (_this, { item }) {
      this.confirmBox(this.$messages.APAGAR_GEO_CADASTRO_PENDENTE, this.$messages.TITULO_APAGAR_GEO_CADASTRO_PENDENTE, async () => {
        try {
          await this.removerAnalise(item.id)
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Georreferenciamento removido com sucesso!')
          this.refresh()
        } catch (e) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            'Ocorreu um erro na remoção do georreferenciamento')
        }
      })
    },
    INSERIR_NUMERO_RECIBO (_this, { item }) {
      this.dadosModal.numeroRecibo = ''
      this.dadosModal.id = item.id
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.showModalVisualizarCadastro = false
      this.dadosModal.numeroRecibo = ''
      this.dadosModal.processo = {}
      this.dadosModal.id = ''
    },
    async vincularRecibo () {
      const isValido = await this.$refs.validationModal.validate()
      if (isValido) {
        const response = await this.vincularGeoCadastro({ id: this.dadosModal.id, numeroRecibo: this.numeroRecibo })
        if (response) {
          this.closeModal()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Georreferenciamento vinculado com sucesso!')
          this.refresh()
        }
      }
    }
  },

  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
  .card-container {
    margin: 20px;
    border-radius: 10px;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
  }
  .dados-cadastro {
   padding: 25px 25px 0;
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaCadastrosPendentesGeo.vue